import * as React from 'react';
import { Emoji } from '../Emoji';
// import * as animations from '@styles/_animations.scss';
import * as customAnimations from './custom-animations.scss';

export const Bat = (props: { text?: string }) => (
  <div
    style={{
      position: 'absolute',
      top: (Math.random() * 2).toString() + '%',
      left: (Math.random() * 80).toString() + '%',
      zIndex: 20,
      animationDelay: `${2 * Math.random()}`,
      animation: customAnimations.fly + ' ' + (Math.random() * 10 + 3).toString() + 's infinite'
    }}
  >
    <Emoji name={Emoji.EmojiNames.Bat} size={50} />
  </div>
);



// WEBPACK FOOTER //
// ./src/common/components/emoji/_components/Bat.tsx